import React from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Input, Modal, Radio, Row } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import { useDeepEffect } from '../../../utils/hooks'
import { inputRule, radioRule } from '../../../utils/rules'

const ForceUpdateForm = (props) => {
  const { formData, visible, onCancel, onOk, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue, resetFields } =
    form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        userAppVersion: formData.userAppVersion,
        appVersionAndroid: formData.appVersionAndroid,
        appVersionIOS: formData.appVersionIOS,
        forceUpdateAndroid: formData.forceUpdateAndroid,
        forceUpdateIOS: formData.forceUpdateIOS,
        storeUrlAndroid: formData.storeUrlAndroid,
        storeUrlIOS: formData.storeUrlIOS
      })
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          userAppVersion: values.userAppVersion,
          appVersionAndroid: values.appVersionAndroid,
          appVersionIOS: values.appVersionIOS,
          forceUpdateAndroid: values.forceUpdateAndroid,
          forceUpdateIOS: values.forceUpdateIOS,
          storeUrlAndroid: values.storeUrlAndroid,
          storeUrlIOS: values.storeUrlIOS,
          forceUpdate: false
        }

        if (!isEmpty(formData)) {
          data.id = formData.id
        }

        onOk(data)
        resetFields()
      }
    })
  }

  return (
    <Modal width={1000} title="App Version" visible={visible} footer={null}>
      <Form onSubmit={onSubmit} layout="vertical">
        <Form.Item label="App User Version">
          {getFieldDecorator(`userAppVersion`, { ...inputRule })(<Input />)}
        </Form.Item>
        <Row gutter={[8, 8]} type="flex">
          <Col span={12}>
            <Form.Item label="Android Version">
              {getFieldDecorator(`appVersionAndroid`, { ...inputRule })(
                <Input />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Force Update Android">
              {getFieldDecorator(`forceUpdateAndroid`, { ...radioRule })(
                <Radio.Group>
                  <Radio value={true}>Enabled</Radio>
                  <Radio value={false}>Disabled</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="IOS Version">
              {getFieldDecorator(`appVersionIOS`, { ...inputRule })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Force Update IOS">
              {getFieldDecorator(`forceUpdateIOS`, { ...radioRule })(
                <Radio.Group>
                  <Radio value={true}>Enabled</Radio>
                  <Radio value={false}>Disabled</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Android Store URL">
          {getFieldDecorator(`storeUrlAndroid`, { ...inputRule })(<Input />)}
        </Form.Item>
        <Form.Item label="IOS Store URL">
          {getFieldDecorator(`storeUrlIOS`, { ...inputRule })(<Input />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedForceUpdateForm = Form.create({
  name: 'ForceUpdateForm'
})(ForceUpdateForm)

export default WrappedForceUpdateForm



// WEBPACK FOOTER //
// ./src/pages/ForceUpdate/ForceUpdateForm/index.js